import './BeginButton.scss';
// Changes showing how to make this component a 1-liner :)
const BeginButton = () => <button className='beginButton' type='submit'>Begin</button>

export default BeginButton